import {
  SUBSCRIPTION_LIST_RECEIVED,
  USER_ACTIVE_SUBSCRIPTION_INFO_RECEIVED,
  SUBSCRIPTION_PROMO_CODE_APPLIED,
  CLEAR_SUBSCRIPTION_PROMO_DETAIL,
} from "../constants/types/subscriptionType";

const initialState = {
  subscriptionList: [],
  userActiveSubscription: null,
  promoDetail: null,
};

export const subscriptionReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUBSCRIPTION_LIST_RECEIVED:
      return {
        ...state,
        subscriptionList: action.payload.map((x) => {
          x.price = (x.price / 100).toFixed(2);
          return x;
        }),
      };
    case USER_ACTIVE_SUBSCRIPTION_INFO_RECEIVED:
      return {
        ...state,
        userActiveSubscription: action.payload,
      };
    case SUBSCRIPTION_PROMO_CODE_APPLIED: {
      return {
        ...state,
        promoDetail: action.payload,
      };
    }
    case CLEAR_SUBSCRIPTION_PROMO_DETAIL: {
      return {
        ...state,
        promoDetail: null,
      };
    }
    default:
      return state;
  }
};
